const FILTERVALUES = {
  totalClear: ["C", "c", "#VALUE!"],
  removeCharacter: ["_", ".", "\\"],
};

export default FILTERVALUES;
